const ALLOWED_HOSTS = new Set([
	"open.docs.suwa3d.com",
	"open.docs.sharewow3d.com",
	"localhost",
	"127.0.0.1"
]);

function isAllowedDocsHost(hostname: string): boolean {
	const host = hostname.trim().toLowerCase();
	if (ALLOWED_HOSTS.has(host)) {
		return true;
	}
	return host.endsWith(".localhost");
}

export function parseOpenapiDocsRedirect(raw: unknown): string {
	const value = String(raw || "").trim();
	if (!value) {
		return "";
	}
	try {
		const url = new URL(value);
		if (url.protocol !== "http:" && url.protocol !== "https:") {
			return "";
		}
		if (!isAllowedDocsHost(url.hostname)) {
			return "";
		}
		return url.toString();
	} catch {
		return "";
	}
}

export function buildOpenapiDocsSsoRedirect(options: {
	redirect: unknown;
	token: unknown;
	shopId?: unknown;
	shopIds?: unknown;
	userId?: unknown;
	userName?: unknown;
}): string {
	const redirect = parseOpenapiDocsRedirect(options.redirect);
	const token = String(options.token || "").trim();
	if (!redirect || !token) {
		return "";
	}

	const url = new URL(redirect);
	url.searchParams.set("sso_token", token);

	const shopId = Number(options.shopId) || 0;
	const shopIds = Array.isArray(options.shopIds)
		? options.shopIds.map((id) => Number(id)).filter((id) => id > 0)
		: [];
	if (shopId > 0) {
		url.searchParams.set("shop_id", String(shopId));
	}
	if (shopIds.length > 0) {
		url.searchParams.set("shop_ids", shopIds.join(","));
	} else if (shopId > 0) {
		url.searchParams.set("shop_ids", String(shopId));
	}

	const userId = String(options.userId || "").trim();
	if (userId) {
		url.searchParams.set("user_id", userId);
	}
	const userName = String(options.userName || "").trim();
	if (userName) {
		url.searchParams.set("user_name", userName);
	}

	return url.toString();
}

export function resolveShopIdsFromUser(info: any): number[] {
	const ids: number[] = [];
	const push = (value: unknown) => {
		const id = Number(Array.isArray(value) ? value[0] : value) || 0;
		if (id > 0 && !ids.includes(id)) {
			ids.push(id);
		}
	};
	push(info?.shopId);
	push(info?.shop_id);
	if (Array.isArray(info?.shops)) {
		info.shops.forEach((item: any) => push(item?.id || item?.shop_id));
	}
	return ids;
}

export function buildOpenapiDocsSsoRedirectFromSession(options: {
	redirect: unknown;
	token: unknown;
	user?: any;
}): string {
	const shopIds = resolveShopIdsFromUser(options.user);
	return buildOpenapiDocsSsoRedirect({
		redirect: options.redirect,
		token: options.token,
		shopId: shopIds[0],
		shopIds,
		userId: options.user?.id,
		userName: options.user?.nickName || options.user?.name || options.user?.username
	});
}

export function tryRedirectOpenapiDocsSso(
	query: Record<string, any> | undefined,
	user: { token?: string; info?: any }
): boolean {
	const url = buildOpenapiDocsSsoRedirectFromSession({
		redirect: query?.redirect_openapi_docs,
		token: user?.token,
		user: user?.info
	});
	if (!url) {
		return false;
	}
	window.location.href = url;
	return true;
}
